module.exports = __webpack_public_path__ + "9749373197a14f802651677b7b6bce90.svg";